import { SequenceUpload } from './models/sequence-upload';

export type VideoUploadsState = {
  [clientCode: string]: {
    [sequenceId: number]: SequenceUpload;
  };
};

export const initialVideoUploadsState: VideoUploadsState = {};
